import { FlexBox } from '@airship-platform/jam-web/components';
import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { z } from 'zod';

export type SOWQueryInputs = { searchTerm: string };

export const SOWQueryFormSchema = z.object({
  searchTerm: z.string(),
});

export type SOWQueryFormInputs = z.infer<typeof SOWQueryFormSchema>;

const SOWQueryForm: React.FC = () => {
  const { control } = useFormContext<SOWQueryInputs>();

  return (
    <FlexBox flexDirection={'column'} width={'100%'} gap={2}>
      <Controller
        name="searchTerm"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            placeholder={'Search by name or description'}
            type="search"
            fullWidth
            autoComplete="off"
          />
        )}
      />
    </FlexBox>
  );
};

export default SOWQueryForm;
